import {TrackingV2GetOrderQuery} from '@data/__generated__/types.main'

export default function getStoreInMapLink(store: TrackingV2GetOrderQuery['order']['store']) {
  return `https://maps.google.com/?q=${store.address?.location?.lat},${store.address?.location?.lng}`
}
